import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkNa } from "../shared/templates";

const app = window.app;

export class MbOutDisplay extends HTMLElement {
	async connectedCallback() {
		await waitForContent("mbOutDisplay");

		this.innerHTML = app.content.mbOutDisplay;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton16", "nextButton16"));

		//prettier-ignore
		const questions = [
			["mer-driver-profile", "Test driver profile selected and security key disabled", false],
			["mer-browser",        "Browser open to 'mbusa.com'",                            false],
			["mer-sirius",         "Sirius XM tuned to ch. 2",                               false],
			["mer-apple-music",    "Apple Music opened and set to MB playlist from library",  true],
			["mer-ridevue",        "Ridevue on main and rear displays",                       true],
			["mer-hov",            "Navigation to avoid HOV lanes / toll roads",             false],
		];

		for (const [name, label, na] of questions) {
			const render = na ? renderQuestionOkNotOkNa : renderQuestionOkNotOk;
			this.querySelector(`#${name}-slot`).replaceWith(render(name, label, 16));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(16, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			const currentRoute = app.routes.mbOutDisplaySettings;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
